export default __webpack_public_path__ + "b97b9c09db90f4f9964c0b69836fe5b2.png";